import React from 'react';

// Copia de containers/Payment/PayPal/screens/components/PayPalAccountsHeader.js.
const LOGO_KEY = 'mdp_metodosdepago_agregarmdppaypal_logo_paypal';

export const PayPalAccountsHeader = ({ assets }) => {
  const logo = assets?.[LOGO_KEY] || '';

  return (
    <header className="paypal-accounts-header">
      <div className="paypal-accounts-header__logo-container">
        {logo && (
          <img
            className="paypal-accounts-header__logo"
            src={logo}
            alt="PayPal"
          />
        )}
      </div>
    </header>
  );
};

export default PayPalAccountsHeader;
